import { Link } from "react-router-dom";
import { categories } from "@/mocks/resources";

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200 mt-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
              <span className="w-9 h-9 rounded-xl bg-primary-500 flex items-center justify-center text-foreground-950">
                <i className="ri-movie-2-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950">
                香蕉<span className="text-primary-600">动漫</span>
              </span>
            </Link>
            <p className="mt-4 text-sm leading-6 text-foreground-700 max-w-sm">
              香蕉动漫资源聚合站，汇总动漫全集资源与资源站目录，一站找齐你想看的热门动漫合集分享，追更不迷路。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["追番不迷路", "全集资源整理", "高清画质", "持续更新"].map((t) => (
                <span
                  key={t}
                  className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs whitespace-nowrap"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base text-foreground-950">站点导航</h3>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700">
              <li><Link className="hover:text-primary-600 transition-colors" to="/">首页</Link></li>
              <li><Link className="hover:text-primary-600 transition-colors" to="/library">资源库</Link></li>
              <li><Link className="hover:text-primary-600 transition-colors" to="/faq">常见问题</Link></li>
              <li><Link className="hover:text-primary-600 transition-colors" to="/about">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-foreground-950">热门分类</h3>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700">
              {categories.slice(0, 4).map((c) => (
                <li key={c.id}>
                  <Link className="hover:text-primary-600 transition-colors" to={`/library?cat=${c.id}`}>
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            © 2026 香蕉动漫 Banana Anime · 专注动漫资源合集与目录整理
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <Link className="hover:text-primary-600 transition-colors" to="/about">关于</Link>
            <Link className="hover:text-primary-600 transition-colors" to="/faq">帮助</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}